import { useEffect, useState } from 'react';
import { Spin } from 'antd';
import moment from 'moment';
import { AllCurrency } from '../../../../api/request/cashDeposit/usdConversion';
import TableWithSkeleton from '../../../../components/global/table/TableWithSkeleton';
import columns from '../../../../columns/cashDeposit/usdConversion/columns';
import MyPagination from '../../../../components/global/pagination/Pagination';

const ConversionHistory = ({ type, setCurrencyid, isRefresh }) => {
    const [data, setData] = useState([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);

    const fetchCurrencyData = async () => {
        setIsLoading(true);
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                FilterText: type,
            };
            const { data } = await AllCurrency(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(
                    data?.data?.map((item, index) => ({
                        ...item,
                        id: index,
                        modifiedDate: item?.modifiedDate ? moment(item?.modifiedDate).format("DD-MM-YYYY, hh:mm A") : "--",
                    }))
                );
                setCurrencyid(data?.data[0]?.id);
                setTotalRecord(data?.totalRecords);
            }
        } catch (error) { }
        finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCurrencyData();
    }, [page, pageSize, isRefresh]);

    return (
        <div className="border-[2px] border-[var(--theme-light)] rounded-xl pt-4 lg:pt-6 w-full mt-5">
            <div className="px-4 lg:px-6 flex flex-col justify-between ">
                <p className="text-[#2F2B3D] text-title font-semibold">{type} Updated History
                    <span className="primary">{isLoading ? (<Spin className="ml-2" size="small" />) : `(${totalRecord})`}</span>
                </p>
            </div>
            <div className="my-6">
                <TableWithSkeleton columns={columns} data={data} loading={isLoading} page={page} pageSize={pageSize} index={true} />
                <MyPagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
            </div>
        </div>
    )
}

export default ConversionHistory